var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerFormulated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.6574 9.3241C22.6344 9.29989 22.6068 9.28063 22.5761 9.2675C22.5455 9.25436 22.5124 9.24762 22.4791 9.2477H0.245245C0.211902 9.24765 0.1789 9.25441 0.148262 9.26756C0.117623 9.28071 0.0899942 9.29999 0.067068 9.3242C0.0441418 9.34841 0.0264017 9.37704 0.0149351 9.40835C0.00346849 9.43966 -0.00148296 9.47298 0.000384277 9.50627C0.166482 12.4071 1.43586 15.1345 3.54833 17.1295C5.6608 19.1245 8.45634 20.2359 11.3619 20.2359C14.2675 20.2359 17.063 19.1245 19.1755 17.1295C21.288 15.1345 22.5574 12.4071 22.7235 9.50627C22.7254 9.47301 22.7206 9.43969 22.7092 9.40837C22.6978 9.37704 22.6802 9.34837 22.6574 9.3241Z",
    fill: "#112314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4213 5.13404L18.9942 8.75798H14.9051L21.3645 2.77358C21.6091 2.5472 21.9196 2.40478 22.2507 2.36691C22.5818 2.32904 22.9164 2.39773 23.2058 2.563C23.6539 2.81766 24.6211 4.09093 23.4213 5.13404Z",
    fill: "#112314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4722 20.2664C16.4722 21.3536 13.1274 21.6426 11.3644 21.6426C9.60137 21.6426 6.25168 21.3536 6.25168 20.2664C6.25803 20.1579 6.2908 20.0525 6.34712 19.9595C6.40345 19.8664 6.48164 19.7886 6.5749 19.7326C8.08314 20.3979 9.71348 20.7415 11.3619 20.7415C13.0104 20.7415 14.6407 20.3979 16.149 19.7326C16.2422 19.7886 16.3204 19.8664 16.3767 19.9595C16.4331 20.0525 16.4658 20.1579 16.4722 20.2664Z",
    fill: "#112314"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFormulated);
export default __webpack_public_path__ + "static/media/banner_formulated.fa6c23090c88df71a6d356a029667d36.svg";
export { ForwardRef as ReactComponent };